(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lox-gift-anatomy"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (customElements.get('lox-gift-anatomy')) return;
  class LoxGiftAnatomy extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.stage = this.querySelector('.ga-stage');
      if (!this.stage) { this.startFrame = requestAnimationFrame(() => this.connectedCallback()); return; }
      this.controller = new AbortController();
      const listen = (node, name, handler, options = {}) => node.addEventListener(name, handler, {...options, signal: this.controller.signal});
      this.mode = this.dataset.interaction || 'follow';
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 989px)');
      this.manualScrollAt = null;
      this.rangeHeld = false;
      this.scrollFrame = null;
      this.strength = Math.max(0, Math.min(1, Number(this.dataset.motionStrength || 0) / 100));
      this.base = Math.max(0, Math.min(1, Number(this.dataset.initialSpread || 0) / 100));
      this.target = this.current = this.base;
      this.x = this.y = this.tx = this.ty = 0;
      this.focus = -1;
      this.pinned = false;
      this.visible = true;
      this.range = this.querySelector('.ga-range');
      this.toggle = this.querySelector('.ga-toggle');
      this.layers = [...this.querySelectorAll('.ga-layer')];
      this.buttons = [...this.querySelectorAll('.ga-layer-button')];
      this.panes = [...this.querySelectorAll('.ga-description')];
      const images = this.layers.map(layer => layer.querySelector('img')).filter(Boolean);
      const ready = () => {
        const loaded = images.length === 4 && images.every(img => img.complete && img.naturalWidth > 0);
        this.classList.toggle('ga-ready', loaded);
        this.dataset.assetsReady = String(loaded);
      };
      images.forEach(img => { listen(img, 'load', ready); listen(img, 'error', ready); });
      ready();
      const setSpread = value => {
        this.holdManual();
        this.select(-1);
        this.target = Math.max(0, Math.min(1, value));
        this.syncControls();
        this.wake();
      };
      listen(this.range, 'input', () => setSpread(Number(this.range.value) / 100));
      listen(this.range, 'pointerdown', () => { this.rangeHeld = true; });
      listen(this.range, 'blur', () => { this.rangeHeld = false; });
      listen(window, 'pointerup', () => { this.rangeHeld = false; });
      listen(window, 'pointercancel', () => { this.rangeHeld = false; });
      listen(this.toggle, 'click', () => setSpread(this.target >= .5 ? 0 : 1));
      this.buttons.forEach((button, index) => listen(button, 'click', () => {
        if (this.mode === 'static') return;
        this.holdManual();
        this.target = 1;
        this.select(this.focus === index ? -1 : index);
        this.syncControls();
        this.wake();
      }));
      listen(this.stage, 'pointerenter', event => {
        if (event.pointerType !== 'mouse' || this.mode !== 'follow' || this.reduced.matches || this.scrollActive) return;
        if (!this.pinned) this.target = this.base + Math.max(0, .8 - this.base) * this.strength;
        this.syncControls();
        this.wake();
      });
      listen(this.stage, 'pointerdown', event => {
        if (this.mode !== 'follow' || event.pointerType === 'mouse' || this.scrollActive) return;
        this.touchStart = {x: event.clientX, y: event.clientY, spread: this.target};
      });
      listen(this.stage, 'pointermove', event => {
        if (this.mode !== 'follow' || this.scrollActive) return;
        const rect = this.stage.getBoundingClientRect();
        const nx = Math.max(-1, Math.min(1, (event.clientX - rect.left) / rect.width * 2 - 1));
        const ny = Math.max(-1, Math.min(1, (event.clientY - rect.top) / rect.height * 2 - 1));
        if (event.pointerType === 'mouse') {
          if (this.reduced.matches) return;
          this.tx = nx * this.strength;
          this.ty = ny * this.strength;
          if (!this.pinned) this.target = this.base + Math.max(0, .68 + (nx + 1) * .16 - this.base) * this.strength;
        } else if (this.touchStart) {
          const dx = event.clientX - this.touchStart.x;
          const dy = event.clientY - this.touchStart.y;
          if (Math.abs(dx) < 8 || Math.abs(dy) > Math.abs(dx)) return;
          if (event.cancelable) event.preventDefault();
          this.holdManual();
          this.select(-1);
          this.target = Math.max(0, Math.min(1, this.touchStart.spread + dx / rect.width * 1.7));
        } else return;
        this.syncControls();
        this.wake();
      }, {passive: false});
      const release = () => { this.touchStart = null; };
      listen(this.stage, 'pointerup', release);
      listen(this.stage, 'pointercancel', release);
      listen(this.stage, 'pointerleave', () => {
        release(); this.tx = this.ty = 0;
        if (!this.pinned && !this.scrollActive) this.target = this.base;
        this.syncControls(); this.wake();
      });
      listen(this.reduced, 'change', () => { this.tx = this.ty = 0; this.configureScroll(); this.wake(); });
      listen(this.mobile, 'change', () => this.configureScroll());
      listen(window, 'scroll', () => this.queueScroll(), {passive: true});
      listen(window, 'resize', () => this.queueScroll(), {passive: true});
      this.range.disabled = this.mode === 'static';
      this.toggle.disabled = this.mode === 'static';
      this.buttons.forEach(button => { button.disabled = this.mode === 'static'; });
      this.select(-1);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) { this.queueScroll(); this.wake(); }
        else { cancelAnimationFrame(this.frame); this.frame = null; cancelAnimationFrame(this.scrollFrame); this.scrollFrame = null; }
      }, {rootMargin: '100px'});
      this.observer.observe(this);
      this.configureScroll();
      this.syncControls();
      this.render();
    }
    holdManual() {
      this.pinned = true;
      this.manualScrollAt = this.scrollActive ? window.scrollY : null;
    }
    configureScroll() {
      const active = this.mobile.matches && this.mode === 'follow' && this.dataset.mobileScroll !== 'false' && !this.reduced.matches;
      const wasActive = this.scrollActive;
      this.scrollActive = active;
      this.dataset.scrollActive = String(active);
      this.tx = this.ty = 0;
      if (active) {
        if (!wasActive && this.pinned) this.manualScrollAt = window.scrollY;
        this.queueScroll();
      }
      else {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        this.manualScrollAt = null;
        if (wasActive && !this.pinned) this.target = this.base;
        this.syncControls();
        this.wake();
      }
    }
    queueScroll() {
      if (!this.controller || !this.scrollActive || !this.visible || this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.updateScrollProgress();
      });
    }
    updateScrollProgress() {
      if (!this.controller || !this.scrollActive || this.rangeHeld) return;
      if (this.manualScrollAt !== null) {
        // Keep a selected layer/slider value until the visitor deliberately scrolls again.
        if (Math.abs(window.scrollY - this.manualScrollAt) < 24) return;
        this.manualScrollAt = null;
        this.pinned = false;
        this.select(-1);
      }
      const viewportHeight = Math.max(1, window.innerHeight);
      const rect = this.stage.getBoundingClientRect();
      // If the gift is already visible on page load, keep its initial pose until scrolling starts.
      const start = Math.min(viewportHeight * .82, Math.max(1, rect.top + window.scrollY));
      const end = Math.min(start - 120, Math.max(64, Math.min(viewportHeight * .22, viewportHeight - rect.height - 92)));
      const progress = Math.max(0, Math.min(1, (start - rect.top) / (start - end)));
      this.target = this.base + (1 - this.base) * progress;
      this.tx = this.ty = 0;
      this.syncControls();
      this.wake();
    }
    select(index) {
      this.focus = index;
      this.dataset.focus = index < 0 ? 'all' : String(index + 1);
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      this.panes.forEach((pane, i) => { pane.hidden = i !== index; });
      this.querySelector('.ga-overview').hidden = index >= 0;
    }
    syncControls() {
      this.range.value = String(Math.round(this.target * 100));
      this.toggle.setAttribute('aria-pressed', String(this.target >= .5));
      this.toggle.querySelector('span').textContent = this.target >= .5 ? (document.documentElement.lang === 'en' ? "Close gift box" : '收合禮盒') : (document.documentElement.lang === 'en' ? "Expand all layers" : '展開四層');
      this.querySelector('.ga-percentage').textContent = `${Math.round(this.target * 100)}%`;
    }
    wake() {
      if (!this.controller || !this.visible || this.frame) return;
      this.frame = requestAnimationFrame(() => this.tick());
    }
    tick() {
      this.frame = null;
      if (!this.controller) return;
      const ease = this.reduced.matches ? 1 : .11;
      this.current += (this.target - this.current) * ease;
      this.x += (this.tx - this.x) * ease;
      this.y += (this.ty - this.y) * ease;
      this.render();
      if (Math.abs(this.current - this.target) + Math.abs(this.x - this.tx) + Math.abs(this.y - this.ty) > .001) this.wake();
    }
    render() {
      const spread = this.current;
      this.style.setProperty('--ga-photo', String(Math.max(0, 1 - spread * 5)));
      this.style.setProperty('--ga-parts', String(Math.min(1, spread * 5)));
      this.style.setProperty('--ga-rx', `${-this.y * 4}deg`);
      this.style.setProperty('--ga-ry', `${this.x * 7}deg`);
      const offsets = [[-7, -30], [-2, -10], [3, 11], [14, 31]];
      this.layers.forEach((layer, index) => {
        const selected = this.focus === index;
        const faded = this.focus >= 0 && !selected;
        const x = selected ? 0 : offsets[index][0] * spread + this.x * (4 - index) * 1.1;
        const y = selected ? 0 : offsets[index][1] * spread + this.y * (4 - index) * .6;
        const scale = selected ? 1.06 : 1 - spread * .18;
        layer.style.transform = `translate(${x}%, ${y}%) rotateX(${selected ? 0 : 28 * spread}deg) rotateZ(${selected ? 0 : -6 * spread}deg) scale(${scale})`;
        layer.style.opacity = faded ? '.14' : '1';
        layer.style.zIndex = selected ? '10' : String(5 - index);
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.scrollFrame);
      this.frame = null;
      this.scrollFrame = null;
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('lox-gift-anatomy', LoxGiftAnatomy);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lox-home-base"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lox-editable-home')) {
    customElements.define('lox-editable-home', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.configureMotion();
        this.motionPreference.addEventListener('change', () => this.configureMotion(), { signal });
        this.addEventListener('shopify:block:select', (event) => { const detail = event.target.closest('details'); if (detail && this.contains(detail)) detail.open = true; }, { signal });
        this.rail = this.querySelector('[data-rail]');
        if (!this.rail) return;
        this.previous = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.progress = this.querySelector('[data-rail-progress]');
        this.querySelector('[data-rail-controls]').hidden = false;
        const scheduleUpdate = () => {
          if (this.railFrame) return;
          this.railFrame = requestAnimationFrame(() => {
            this.railFrame = null;
            this.updateRail();
          });
        };
        this.rail.addEventListener('scroll', scheduleUpdate, { passive: true, signal });
        this.previous.addEventListener('click', () => this.moveRail(-1), { signal });
        this.next.addEventListener('click', () => this.moveRail(1), { signal });
        this.rail.addEventListener('keydown', (event) => {
          if (event.target !== this.rail) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            this.moveRail(event.key === 'ArrowLeft' ? -1 : 1);
          } else {
            this.rail.scrollTo({ left: event.key === 'Home' ? 0 : this.rail.scrollWidth, behavior: this.scrollBehavior() });
          }
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('.le-case');
          if (card) this.rail.scrollTo({ left: this.rail.scrollLeft + card.getBoundingClientRect().left - this.rail.getBoundingClientRect().left - parseFloat(getComputedStyle(this.rail).paddingLeft), behavior: 'auto' });
        }, { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(scheduleUpdate);
          this.resizeObserver.observe(this.rail);
        }
        this.updateRail();
      }
      configureMotion() {
        this.revealObserver?.disconnect();
        this.querySelectorAll('.le-pending').forEach((element) => element.classList.remove('le-pending'));
        this.motionEnabled = this.dataset.motion === 'true' && !this.motionPreference.matches;
        this.classList.toggle('le-motion', this.motionEnabled);
        if (!this.motionEnabled || !('IntersectionObserver' in window)) return;
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('le-pending');
            this.revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0, rootMargin: '0px 0px -35px 0px' });
        this.querySelectorAll('[data-reveal]').forEach((element) => {
          if (element.getBoundingClientRect().top > window.innerHeight) {
            element.classList.add('le-pending');
            this.revealObserver.observe(element);
          }
        });
      }
      scrollBehavior() {
        return this.motionEnabled ? 'smooth' : 'auto';
      }
      moveRail(direction) {
        const card = this.rail.querySelector('.le-case');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap || 0);
        this.rail.scrollBy({ left: direction * step, behavior: this.scrollBehavior() });
      }
      updateRail() {
        if (!this.rail) return;
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        this.previous.disabled = this.rail.scrollLeft <= 2;
        this.next.disabled = this.rail.scrollLeft >= maximum - 2;
        this.progress.style.transform = `scaleX(${Math.min(1, (this.rail.scrollLeft + this.rail.clientWidth) / Math.max(1, this.rail.scrollWidth))})`;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.revealObserver?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.railFrame) cancelAnimationFrame(this.railFrame);
        this.railFrame = null;
        this.querySelectorAll('.le-pending').forEach((element) => element.classList.remove('le-pending'));
      }
    });
  }
(() => {
  'use strict';
  if (customElements.get('lox-editable-stone')) return;

  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const identity = () => new Float32Array([1,0,0,0, 0,1,0,0, 0,0,1,0, 0,0,0,1]);
  const multiply = (a, b) => {
    const out = new Float32Array(16);
    for (let c = 0; c < 4; c++) for (let r = 0; r < 4; r++)
      out[c * 4 + r] = a[r] * b[c * 4] + a[4 + r] * b[c * 4 + 1] + a[8 + r] * b[c * 4 + 2] + a[12 + r] * b[c * 4 + 3];
    return out;
  };
  const translate = (x, y, z) => { const m = identity(); m[12] = x; m[13] = y; m[14] = z; return m; };
  const rotate = (x, y, z) => {
    const sx = Math.sin(x), cx = Math.cos(x), sy = Math.sin(y), cy = Math.cos(y), sz = Math.sin(z), cz = Math.cos(z);
    return multiply(multiply(new Float32Array([cy,0,-sy,0, 0,1,0,0, sy,0,cy,0, 0,0,0,1]), new Float32Array([1,0,0,0, 0,cx,sx,0, 0,-sx,cx,0, 0,0,0,1])), new Float32Array([cz,sz,0,0, -sz,cz,0,0, 0,0,1,0, 0,0,0,1]));
  };
  const perspective = (aspect) => {
    const f = 1 / Math.tan(31 * Math.PI / 360), near = .1, far = 30;
    return new Float32Array([f/aspect,0,0,0, 0,f,0,0, 0,0,(far+near)/(near-far),-1, 0,0,2*far*near/(near-far),0]);
  };

  function arch(inset = 0) {
    const r = .77 - inset, floor = -1.05 + inset, cy = .36;
    const points = [[-r, floor], [r, floor], [r, cy]];
    for (let i = 1; i <= 64; i++) {
      const a = Math.PI * i / 64;
      points.push([Math.cos(a) * r, cy + Math.sin(a) * r]);
    }
    return points;
  }
  function newMesh() { return { positions: [], normals: [] }; }
  function tri(mesh, a, b, c, normal) {
    let n = normal;
    if (!n) {
      const u = b.map((v,i) => v-a[i]), v = c.map((s,i) => s-a[i]);
      n = [u[1]*v[2]-u[2]*v[1], u[2]*v[0]-u[0]*v[2], u[0]*v[1]-u[1]*v[0]];
      const len = Math.hypot(...n) || 1; n = n.map(v => v/len);
    }
    mesh.positions.push(...a,...b,...c); mesh.normals.push(...n,...n,...n);
  }
  function quad(mesh,a,b,c,d,n) { tri(mesh,a,b,c,n); tri(mesh,a,c,d,n); }
  function archSolid(depth, bevel = .025) {
    const mesh = newMesh(), outer = arch(), inner = arch(bevel), half = depth/2;
    const rings = [{p:inner,z:-half},{p:outer,z:-half+bevel},{p:outer,z:half-bevel},{p:inner,z:half}];
    for (let k = 0; k < rings.length-1; k++) {
      const a=rings[k],b=rings[k+1];
      for (let i=0;i<a.p.length;i++) {
        const j=(i+1)%a.p.length;
        quad(mesh,[...a.p[i],a.z],[...a.p[j],a.z],[...b.p[j],b.z],[...b.p[i],b.z]);
      }
    }
    for (let i=0;i<inner.length;i++) {
      const j=(i+1)%inner.length;
      tri(mesh,[0,0,half],[...inner[i],half],[...inner[j],half],[0,0,1]);
      tri(mesh,[0,0,-half],[...inner[j],-half],[...inner[i],-half],[0,0,-1]);
    }
    return mesh;
  }

  function archBand(radius, width, z, height) {
    const mesh = newMesh(), cy=.36, bottom=-.88, path=[];
    path.push({x:-radius,y:bottom,nx:-1,ny:0});
    for(let i=0;i<=64;i++) {
      const a=Math.PI-Math.PI*i/64;
      path.push({x:Math.cos(a)*radius,y:cy+Math.sin(a)*radius,nx:Math.cos(a),ny:Math.sin(a)});
    }
    path.push({x:radius,y:bottom,nx:1,ny:0});
    const profile=[[-width*.5,0],[-width*.34,height*.65],[0,height],[width*.34,height*.65],[width*.5,0]];
    for(let i=0;i<path.length-1;i++) for(let k=0;k<profile.length-1;k++) {
      const a=path[i],b=path[i+1],p=profile[k],q=profile[k+1];
      quad(mesh,[a.x+a.nx*p[0],a.y+a.ny*p[0],z+p[1]], [b.x+b.nx*p[0],b.y+b.ny*p[0],z+p[1]], [b.x+b.nx*q[0],b.y+b.ny*q[0],z+q[1]], [a.x+a.nx*q[0],a.y+a.ny*q[0],z+q[1]]);
    }
    return mesh;
  }
  function medallion(z) {
    const mesh=newMesh(),r=.056,y=-.95;
    for(let i=0;i<40;i++) { const a=i*Math.PI/20,b=(i+1)*Math.PI/20; tri(mesh,[0,y,z],[Math.cos(a)*r,y+Math.sin(a)*r,z],[Math.cos(b)*r,y+Math.sin(b)*r,z],[0,0,1]); }
    return mesh;
  }

  const vertexSource = `
    attribute vec3 aPosition; attribute vec3 aNormal;
    uniform mat4 uProjection; uniform mat4 uModel;
    varying vec3 vNormal; varying vec3 vPosition; varying vec3 vLocal;
    void main(){ vec4 p=uModel*vec4(aPosition,1.0); vPosition=p.xyz;vNormal=mat3(uModel)*aNormal;vLocal=aPosition;gl_Position=uProjection*vec4(p.xyz+vec3(0.0,0.0,-6.15),1.0); }
  `;
  const fragmentSource = `
    precision highp float;
    varying vec3 vNormal;varying vec3 vPosition;varying vec3 vLocal;
    uniform vec3 uColor;uniform float uRoughness;uniform float uPores;
    float hash(vec3 p){p=fract(p*.3183099+vec3(.1,.2,.3));p*=17.0;return fract(p.x*p.y*p.z*(p.x+p.y+p.z));}
    void main(){
      vec3 n=normalize(vNormal);if(!gl_FrontFacing)n=-n;
      vec3 light=normalize(vec3(-.55,.85,1.15));vec3 fill=normalize(vec3(.75,.05,.55));
      vec3 view=normalize(vec3(0.0,0.0,6.15)-vPosition);
      float diffuse=max(dot(n,light),0.0),bounce=max(dot(n,fill),0.0);
      float rim=pow(1.0-max(dot(n,view),0.0),3.0);
      float grain=hash(floor(vLocal*620.0));float pore=step(.97,hash(floor(vLocal*103.0)));
      float material=1.0+(grain-.5)*.07-uPores*pore*.10;
      vec3 base=uColor*material*(.33+diffuse*.67+bounce*.17);
      float spec=pow(max(dot(n,normalize(light+view)),0.0),mix(65.0,12.0,uRoughness));
      base+=vec3(1.0,.92,.79)*spec*(1.0-uRoughness)*.24+vec3(.11,.095,.07)*rim;
      gl_FragColor=vec4(base,1.0);
    }
  `;

  class LoxStoneAnatomy extends HTMLElement {
    connectedCallback() {
      if(this._active||!this.isConnected)return;

      if(!this.querySelector('canvas')||!this.querySelector('.la-stage')||!this.querySelector('.la-range')||!this.querySelector('.la-toggle')) {
        if(!this._pending)this._pending=requestAnimationFrame(()=>{this._pending=0;this.connectedCallback();});return;
      }
      this._active=true;this._failed=false;this._contextLost=false;this._listeners=[];this._meshes=[];
      this.classList.remove('la-no-webgl');
      this.stage=this.querySelector('.la-stage');this.canvas=this.querySelector('canvas');
      this.range=this.querySelector('.la-range');this.button=this.querySelector('.la-toggle');
      this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      const percent=(value,fallback)=>value===undefined||value.trim()===''||!Number.isFinite(Number(value))?fallback:clamp(Number(value),0,100)/100;
      this.interaction=['follow','manual','static'].includes(this.dataset.interaction)?this.dataset.interaction:'follow';
      this.initialSpread=percent(this.dataset.initialSpread,.1);this.motionStrength=percent(this.dataset.motionStrength,1);
      this.state={x:.14,y:-.43,e:this.initialSpread};this.target={...this.state};
      this._visible=true;this._drag=false;this._touchStart=null;this._raf=0;this._lastTime=0;
      this.range.disabled=this.button.disabled=this.interaction==='static';this.syncControls();
      try { this.initGL(); } catch(error) { this.destroyGL();this.classList.add('la-no-webgl');this._failed=true;return; }
      this.classList.add('la-ready');
      if(this.interaction==='follow'&&this.motionStrength>0){
        this.listen(this.stage,'pointermove',event=>this.pointer(event));
        this.listen(this.stage,'pointerdown',event=>{
          if(this.reduced.matches)return;
          if(event.pointerType==='touch'){this._drag=true;this.stage.setPointerCapture(event.pointerId);this._touchStart={x:event.clientX,y:event.clientY};}
          this.pointer(event);
        });
        const release=()=>{this._drag=false;this._touchStart=null;};
        this.listen(this.stage,'pointerup',release);this.listen(this.stage,'pointercancel',release);this.listen(this.stage,'lostpointercapture',release);
        this.listen(this.stage,'pointerleave',()=>{if(!this._drag){this.target.x=.14;this.target.y=-.43;this.requestFrame();}});
      }
      if(this.interaction!=='static'){
        this.listen(this.range,'input',()=>{const value=Number(this.range.value);if(Number.isFinite(value))this.target.e=clamp(value,0,100)/100;this.syncControls();this.requestFrame();});
        this.listen(this.button,'click',()=>{this.target.e=this.target.e>.45?0:1;this.target.y=-.60;this.syncControls();this.requestFrame();});
      }
      this.listen(this.reduced,'change',()=>this.requestFrame());
      this.listen(document,'visibilitychange',()=>{if(!document.hidden)this.requestFrame();else this.stop();});
      this.listen(this.canvas,'webglcontextlost',event=>{event.preventDefault();this._contextLost=true;this.stop();this.classList.remove('la-ready');this.classList.add('la-no-webgl');});
      this.listen(this.canvas,'webglcontextrestored',()=>{this.destroyGL();try{this.initGL();this._contextLost=false;this._failed=false;this.classList.remove('la-no-webgl');this.classList.add('la-ready');this.resize();this.requestFrame();}catch(error){this.destroyGL();this._failed=true;this.classList.remove('la-ready');this.classList.add('la-no-webgl');}});
      if('ResizeObserver' in window){this._resize=new ResizeObserver(()=>{this.resize();this.requestFrame();});this._resize.observe(this.stage);}
      else this.listen(window,'resize',()=>{this.resize();this.requestFrame();});
      if('IntersectionObserver' in window){this._intersection=new IntersectionObserver(entries=>{this._visible=entries[0].isIntersecting;if(this._visible)this.requestFrame();else this.stop();},{rootMargin:'100px'});this._intersection.observe(this);}
      this.resize();this.requestFrame();
    }
    listen(target,type,handler){target.addEventListener(type,handler);this._listeners.push(()=>target.removeEventListener(type,handler));}
    pointer(event){
      if(this.interaction!=='follow'||this.reduced.matches||this.motionStrength<=0)return;
      if(event.pointerType==='touch'&&!this._drag)return;
      if(event.pointerType==='touch'&&this._touchStart&&Math.abs(event.clientY-this._touchStart.y)>Math.abs(event.clientX-this._touchStart.x)*1.3)return;
      const r=this.stage.getBoundingClientRect(),nx=clamp((event.clientX-r.left)/r.width*2-1,-1,1),ny=clamp((event.clientY-r.top)/r.height*2-1,-1,1);
      this.target.x=.14+ny*.24*this.motionStrength;this.target.y=-.43+(-.05+nx*.37)*this.motionStrength;

      this.target.e=this.initialSpread+(clamp((nx+1)*.52,0,1)-this.initialSpread)*this.motionStrength;this.syncControls();
      this.requestFrame();
    }
    syncControls(){
      this.range.value=Math.round(this.target.e*100);const expanded=this.target.e>.45;
      this.button.setAttribute('aria-pressed',String(expanded));this.button.querySelector('span').textContent=expanded?(this.dataset.labelCollapse||(document.documentElement.lang === 'en' ? "Close" : '合起')):(this.dataset.labelExpand||(document.documentElement.lang === 'en' ? "Expand" : '展開'));
      this.classList.toggle('la-expanded',this.target.e>.3);
    }
    initGL(){
      const gl=this.canvas.getContext('webgl',{alpha:true,antialias:true,premultipliedAlpha:false,powerPreference:'low-power'});
      if(!gl)throw new Error('WebGL is unavailable');this.gl=gl;
      const compile=(source,type)=>{const shader=gl.createShader(type);gl.shaderSource(shader,source);gl.compileShader(shader);if(!gl.getShaderParameter(shader,gl.COMPILE_STATUS)){gl.deleteShader(shader);throw new Error('Shader compilation failed');}return shader;};
      const vert=compile(vertexSource,gl.VERTEX_SHADER),frag=compile(fragmentSource,gl.FRAGMENT_SHADER);
      const program=gl.createProgram();gl.attachShader(program,vert);gl.attachShader(program,frag);gl.linkProgram(program);gl.deleteShader(vert);gl.deleteShader(frag);
      if(!gl.getProgramParameter(program,gl.LINK_STATUS)){gl.deleteProgram(program);throw new Error('Shader link failed');}
      this.program=program;gl.useProgram(program);
      this.locations={position:gl.getAttribLocation(program,'aPosition'),normal:gl.getAttribLocation(program,'aNormal'),projection:gl.getUniformLocation(program,'uProjection'),model:gl.getUniformLocation(program,'uModel'),color:gl.getUniformLocation(program,'uColor'),roughness:gl.getUniformLocation(program,'uRoughness'),pores:gl.getUniformLocation(program,'uPores')};
      const add=(geometry,color,part,roughness=.9,pores=.5)=>{
        const position=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,position);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(geometry.positions),gl.STATIC_DRAW);
        const normal=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,normal);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(geometry.normals),gl.STATIC_DRAW);
        this._meshes.push({position,normal,count:geometry.positions.length/3,color,part,roughness,pores});
      };
      add(archSolid(.13,.020),[.77,.735,.68],-1,.96,.7);
      add(archSolid(.17,.022),[.90,.875,.824],0,.98,1);
      add(archSolid(.13,.022),[.965,.943,.891],1,.88,.5);
      for(const radius of [.645,.535,.425,.315,.205]) {
        add(archBand(radius,.040,.0655,.002),[.64,.60,.53],1,.99,.1);
        add(archBand(radius,.027,.069,.019),[.99,.967,.911],1,.8,.25);
      }
      add(medallion(.067),[.62,.48,.29],1,.40,0);
      gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);gl.clearColor(0,0,0,0);
    }
    resize(){
      if(!this.gl)return;const r=this.stage.getBoundingClientRect();if(!r.width||!r.height)return;
      const dpr=Math.min(window.devicePixelRatio||1,1.8),w=Math.round(r.width*dpr),h=Math.round(r.height*dpr);
      if(this.canvas.width!==w||this.canvas.height!==h){this.canvas.width=w;this.canvas.height=h;this.gl.viewport(0,0,w,h);}
      this._aspect=w/h;
    }
    requestFrame(){if(!this._raf&&this._active&&this._visible&&!document.hidden&&!this._failed&&!this._contextLost)this._raf=requestAnimationFrame(time=>this.frame(time));}
    stop(){if(this._raf)cancelAnimationFrame(this._raf);this._raf=0;this._lastTime=0;}
    frame(time){
      this._raf=0;if(!this._active||!this.gl||!this._visible||document.hidden)return;
      const dt=this._lastTime?Math.min(time-this._lastTime,50):16;this._lastTime=time;
      const easing=this.interaction==='static'||this.reduced.matches?1:1-Math.exp(-dt/140);let moving=false;
      for(const key of ['x','y','e']){this.state[key]+=(this.target[key]-this.state[key])*easing;if(Math.abs(this.target[key]-this.state[key])>.0005)moving=true;}
      const gl=this.gl,l=this.locations;gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.useProgram(this.program);
      gl.uniformMatrix4fv(l.projection,false,perspective(this._aspect||1));
      const rotation=rotate(this.state.x,this.state.y,-.065),e=this.state.e;
      for(const mesh of this._meshes){

        const p=mesh.part,z=p===1?.153:p===-1?-.153:0;
        const model=multiply(rotation,translate(-p*e*.62,p*e*.12,z+p*e*.50));
        gl.uniformMatrix4fv(l.model,false,model);gl.uniform3fv(l.color,mesh.color);gl.uniform1f(l.roughness,mesh.roughness);gl.uniform1f(l.pores,mesh.pores);
        gl.bindBuffer(gl.ARRAY_BUFFER,mesh.position);gl.enableVertexAttribArray(l.position);gl.vertexAttribPointer(l.position,3,gl.FLOAT,false,0,0);
        gl.bindBuffer(gl.ARRAY_BUFFER,mesh.normal);gl.enableVertexAttribArray(l.normal);gl.vertexAttribPointer(l.normal,3,gl.FLOAT,false,0,0);gl.drawArrays(gl.TRIANGLES,0,mesh.count);
      }
      if(moving)this.requestFrame();else this._lastTime=0;
    }
    destroyGL(){if(!this.gl)return;for(const mesh of this._meshes){this.gl.deleteBuffer(mesh.position);this.gl.deleteBuffer(mesh.normal);}this._meshes=[];if(this.program)this.gl.deleteProgram(this.program);this.program=null;}
    disconnectedCallback(){
      this._active=false;this.stop();if(this._pending)cancelAnimationFrame(this._pending);this._pending=0;
      if(this._listeners)this._listeners.forEach(remove=>remove());if(this._resize)this._resize.disconnect();if(this._intersection)this._intersection.disconnect();
      this._listeners=[];this._resize=null;this._intersection=null;this._drag=false;this._touchStart=null;
      this.destroyGL();this.gl=null;this.classList.remove('la-ready');
    }
  }
  customElements.define('lox-editable-stone',LoxStoneAnatomy);
})();
  } catch(e) { console.error(e); }
})();

})();
